import React from 'react';
import { Check } from 'lucide-react';

interface StepIndicatorProps {
  steps: string[];
  currentStep: number;
}

export default function StepIndicator({ steps, currentStep }: StepIndicatorProps) {
  return (
    <div className="card-elevated p-4">
      <div className="flex items-center">
        {steps.map((step, index) => (
          <React.Fragment key={`step-${step}`}>
            <div className="flex flex-col items-center">
              <div
                className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-300 ${
                  index < currentStep
                    ? 'step-completed'
                    : index === currentStep
                    ? 'step-active shadow-md'
                    : 'step-inactive'
                }`}
              >
                {index < currentStep ? <Check size={16} /> : index + 1}
              </div>
              <span
                className={`text-[10px] font-semibold mt-1.5 tracking-wide transition-colors ${
                  index <= currentStep ? 'text-foreground' : 'text-muted-foreground'
                }`}
              >
                {step}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div className="flex-1 mx-2 mb-5">
                <div className="h-0.5 w-full bg-border rounded-full overflow-hidden">
                  <div
                    className="h-full bg-primary transition-all duration-500"
                    style={{ width: index < currentStep ? '100%' : '0%' }}
                  />
                </div>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}